import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  ActivityAdvisorsRequest,
  ActivityAdvisorsResponse,
  ActivityRequest,
  ActivityResponse,
  ActivitySavedFiltersModel,
  AutomaticActionModel,
  CreateAutomaticActionRequest,
  ReferenceTemplateModel,
  TemplateVariablesResponse,
  UpdateAutomaticActionRequest,
} from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  constructor(private http: HttpClient) {}

  public getActivity(request: ActivityRequest): Observable<ActivityResponse> {
    return this.http.post<ActivityResponse>(`${environment.apiEndpoint}/activity/b2b/search/log`, request);
  }

  public getActivityAdvisors(request: ActivityAdvisorsRequest): Observable<ActivityAdvisorsResponse> {
    return this.http.post<ActivityAdvisorsResponse>(`${environment.apiEndpoint}/activity/b2b/search/advisor`, request);
  }

  public getSavedActivityFilters(): Observable<ActivitySavedFiltersModel> {
    return this.http.get<ActivitySavedFiltersModel>(`${environment.apiEndpoint}/activity/b2b/filters`);
  }

  // --- Automatic Actions ---

  public getAutomaticActions(): Observable<AutomaticActionModel[]> {
    return this.http.get<AutomaticActionModel[]>(`${environment.apiEndpoint}/activity/b2b/automatic-actions`);
  }

  public createAutomaticAction(request: CreateAutomaticActionRequest): Observable<AutomaticActionModel> {
    return this.http.post<AutomaticActionModel>(`${environment.apiEndpoint}/activity/b2b/automatic-actions`, request);
  }

  public updateAutomaticAction(id: number, request: UpdateAutomaticActionRequest): Observable<AutomaticActionModel> {
    return this.http.put<AutomaticActionModel>(
      `${environment.apiEndpoint}/activity/b2b/automatic-actions/${id}`,
      request,
    );
  }

  public deleteAutomaticAction(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiEndpoint}/activity/b2b/automatic-actions/${id}`);
  }

  public toggleAutomaticAction(id: number): Observable<AutomaticActionModel> {
    return this.http.patch<AutomaticActionModel>(
      `${environment.apiEndpoint}/activity/b2b/automatic-actions/${id}/toggle`,
      {},
    );
  }

  public uploadAttachmentToS3(uploadUrl: string, file: File): Observable<HttpResponse<string>> {
    return this.http.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
        'Content-Disposition': `attachment; filename="${file.name}"`,
      },
      observe: 'response',
      responseType: 'text',
    });
  }

  public getEventTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiEndpoint}/activity/b2b/automatic-actions/event-types`);
  }

  public getReferenceTemplates(): Observable<ReferenceTemplateModel[]> {
    return this.http.get<ReferenceTemplateModel[]>(
      `${environment.apiEndpoint}/activity/b2b/automatic-actions/reference-templates`,
    );
  }

  public getReferenceTemplate(id: number): Observable<ReferenceTemplateModel> {
    return this.http.get<ReferenceTemplateModel>(
      `${environment.apiEndpoint}/activity/b2b/automatic-actions/reference-templates/${id}`,
    );
  }

  public getTemplateVariables(eventType: string): Observable<TemplateVariablesResponse> {
    return this.http.get<TemplateVariablesResponse>(
      `${environment.apiEndpoint}/activity/b2b/automatic-actions/template-variables`,
      { params: { eventType } },
    );
  }
}
